import { Radio } from '@ksyos/design-system';
import type { OsasConsultData } from '@common/validation/customControls/osas/osasConsultSchemas/types';
import type { OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import type { ValidationErrors } from '@frontend/utils';
import { CpapOption } from '@common/enums';
import { RadioGroupFormGroup, TextAreaFormGroup } from '../../../../processActivityFormGroupFields';

type CpapSettingProps = {
    data: OsasTreatmentData;
    errors: ValidationErrors;
    onChange: (data: Partial<OsasTreatmentData>, validateKeys?: string | string[] | undefined) => void;
};

export function CpapSetting(props: Readonly<CpapSettingProps>) {
    const { data, errors, onChange } = props;

    return (
        <>
            <RadioGroupFormGroup
                fieldKey="cpapSetting"
                hasErrors={errors.has('cpapSetting') || errors.has('cpapSettingText')}
                isRequired={true}
                label="CPAP instellingen"
                onChange={async (value) => {
                    const updatedData: Partial<OsasConsultData> = {
                        cpapSetting: (value as CpapOption) ?? null,
                    };

                    let fieldsToValidate = ['cpapSetting'];
                    if (value === CpapOption.standard) {
                        updatedData.cpapSettingText = null;
                        fieldsToValidate = [...fieldsToValidate, 'cpapSettingText'];
                    }

                    onChange(updatedData, fieldsToValidate);
                }}
                radioGroupLayout="column"
                value={data.cpapSetting ?? undefined}
            >
                <Radio
                    key={CpapOption.standard}
                    label="Standaard"
                    value={CpapOption.standard}
                />
                <Radio
                    key={CpapOption.custom}
                    label="Aangepast, namelijk..."
                    value={CpapOption.custom}
                />
            </RadioGroupFormGroup>

            {data.cpapSetting === CpapOption.custom && (
                <TextAreaFormGroup
                    fieldKey="cpapSettingText"
                    label=""
                />
            )}
        </>
    );
}
